export const enum PhoneValidationKind {
    Numeric = 'Numeric',
    CountryFormat = 'CountryFormat',
}
